import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/work-schedules', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/work-schedules', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const save = data => {
  return httpClient
    .post('/api/work-schedules/save/copy', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getShift = (Option = {}) => {
  return httpClient
    .get(
      '/api/shift-managements?page=-1&fields[hris_shifts]=shift_id,shift_name,shift_type&filter[except_normal]=Normal'
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSpecialKeyword = (options = {}) => {
  return httpClient
    .get('/api/work-schedules/special-keyword', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const exportExcel = attributes => {
  return httpClient
    .post('/api/work-schedules/excel', attributes, { responseType: 'arraybuffer' })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, store, find, getShift, getSpecialKeyword, save, exportExcel }
